import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {loginStats_template} from "../components/templates/loginStats_template";

declare var ko: any;

export class loginStats extends vnModule_knockoutJS {

    protected loginStats_template: loginStats_template;
    protected moduleXHRHdl : XMLHttpRequestHandler;

    protected getModuleName(): string {
        return 'loginStats';
    }

    buildContent(): Array<Element> {
        this.loginStats_template = new loginStats_template('loginStats', this.viewModel, this);

        this.template = this.loginStats_template;

        return [this.loginStats_template.build()];
    }

    public fillPage() : void{
        this.loginStats_template.buildDatePickerCalendar();

        // First get the presets
        this.getSearchPresetsListData();
    }

    protected getListFormData() {
        let usrReq_url: string = '/api/loginStats/references/';
        let usrReq_params: Array<Array<string>> = [];

        this.moduleXHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.moduleXHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.moduleXHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj) {
        return function() {
            obj.manageResponse(req, obj, function() {

                let response = JSON.parse(req.request.response);

                obj.loginStats_template.validationsList.clearMessages();
                obj.updateFilters(response);
                obj.updateViewModelFromPath();
                obj.getListData();
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.loginStats_template.builtTemplate);
            }
        }
    }

    protected updateFilters(responseParsed: any){

        this.loginStats_template.setViewModesItems();
        this.loginStats_template.setBrandFilterItems(responseParsed.departments);
        this.loginStats_template.setCountriesFilterItems(responseParsed.countries);
        this.loginStats_template.setDeviceOptionsFilterItems();
    }

    public getListData() {

        this.loadingIn(this.loginStats_template.builtTemplate.children.namedItem("list-results"));

        let subViewModel = this.loginStats_template.getViewModelForRequest();
        let baseApiUrl = '/api/loginStats/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj) {


        return function (){

            obj.manageResponse(req, obj, function (){

                let response = JSON.parse(req.request.response);

                // console.log(response)

                obj.loginStats_template.resetSelectedRows();
                obj.loginStats_template.validationsList.clearMessages();
                obj.updateList( response.data );

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    obj.loadingOut(obj.loginStats_template.builtTemplate.children.namedItem("list-results"));
                }
            }

        };
    }

    protected updateList(data) {

        this.loginStats_template.setRevenuePermissions(data.revenuePermissions);

        if (data.viewMode == 'daily') {

            for (let item of data.loginStats) {

                item.rawDate = (item.date + '').substring(0, 10);
                item.date = this.formatDate(item.date + "T12:00:00");
            }
            this.loginStats_template.setLoginStatsDaily(data.loginStats);
        }else if (data.viewMode == 'brands') {

            this.loginStats_template.setLoginStatsBrands(data.loginStats);
        }
        this.loginStats_template.setDynamicEventNames(data.dynamicEventNames);
        this.loginStats_template.setLoginStatsTotals(data.totals);
        this.loginStats_template.setTotalActiveAccounts(data.totalActiveAccounts);
        this.loginStats_template.setTotalVerifiedAccounts(data.totalVerifiedAccounts);
        this.loginStats_template.setTotalProfiles(data.totalProfiles);
        this.loginStats_template.setTotalIndexedProfiles(data.totalIndexedProfiles);
        this.loginStats_template.setTotalPremiumUsers(data.totalPremiumUsers);
        this.loginStats_template.setTotalPremiumTrials(data.totalPremiumTrials);
        this.loginStats_template.setMonthlyPremiumUsers(data.monthlyPremiumUsers);
        this.loginStats_template.setYearlyPremiumUsers(data.yearlyPremiumUsers);

    }

    protected filterDateOnChange() {

        this.getListData();
    }

    protected filterMultipleSelectorOnChange(){

        this.getListData();
    }

    protected filterSimpleCancel(){

        if( this.moduleXHRHdl ){

            this.moduleXHRHdl.cancelAndReset();
        }
    }
    
    protected filterSimpleOnChange(){

        this.getListData();
    }

    private formatDate(date) {
        let weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";

        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            dayOfWeek = weekday[d.getDay()];


        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return dayOfWeek + ', ' + [year, month, day].join('-');
    }

}



// WEBPACK FOOTER //
// ./js/modules/loginStats.ts